import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { ChatBot } from '@/components/ChatBot'
import { CookieBanner } from '@/components/CookieBanner'

export function Layout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main id="main-content" className="flex-1 pt-16 md:pt-20">
        <Outlet />
      </main>
      <Footer />
      <ChatBot />
      <CookieBanner />
    </div>
  )
}
